import { coreConfigurationFactory } from '@/api/utils/auth.provider';
import { parsePhone } from '@/api/utils/phone';
import { AccountsApi, ApiTransactionAPIModel, FiatAccountAPIModel, TransactionApi } from '@/generated/api/fps/core';
import { MoneyType, TransactionId } from '@/model/common';
import { Transaction } from '@/model/wallets/types';

import { Wallet } from './types';

const transactionApi = new TransactionApi(coreConfigurationFactory('auth'));
const accountsApi = new AccountsApi(coreConfigurationFactory('auth'));

const parseMoney = (amount: string): MoneyType => Number.parseFloat(amount) * 100;

export const parseWallet = ({ balance, ...wallet }: FiatAccountAPIModel): Wallet => ({
  ...wallet,
  balance: { ...balance, amount: parseFloat(balance.amount) * 100 },
});

export const parseTransaction = ({
  amount,
  accountFromFee,
  accountToFee,
  sbpInfo,
  ...data
}: ApiTransactionAPIModel): Transaction => ({
  ...data,
  amount: parseMoney(amount),
  accountFromFee: parseMoney(accountFromFee),
  accountToFee: parseMoney(accountToFee),
  sbpInfo: sbpInfo
    ? { ...sbpInfo, senderPhone: sbpInfo.senderPhone ? parsePhone(sbpInfo.senderPhone) : undefined }
    : undefined,
});

export const queryTransactions = async (
  filter: { dateFrom?: Date; dateTo?: Date },
  { page, perPage }: { page: number; perPage?: number },
): Promise<Transaction[]> =>
  (
    (
      await transactionApi.getTransactionHistory({
        dateFrom: filter.dateFrom,
        dateTo: filter.dateTo,
        page: {
          limit: perPage || 25,
          offset: (page - 1) * (perPage || 25),
          // "ts" is from Moneta API
          sortBy: [{ col: 'ts', asc: false }],
        },
      })
    ).transactions || []
  ).map(parseTransaction);

export const queryTransaction = async (transactionId: TransactionId): Promise<Transaction> =>
  parseTransaction(await transactionApi.getTransactionById(transactionId));

export const queryWallets = async (): Promise<Wallet[]> =>
  ((await accountsApi.getFiatAccounts()) || []).map(parseWallet);
